import * as React from "react";
import cx from "classnames";
import { WrappedFieldMetaProps, FieldArrayMetaProps } from "redux-form";

import http from "../../helpers/http";
import Layout from "./Layout";
import "./Dropzone.css";

export interface UploadOptions {
  getSignedUrl: (file: File, callback: (a: any) => void) => void;
  uploadRequestHeaders: any;
}

export interface UploadedFileResponse {
  file: File;
  signedUrl: string;
  bucket: string;
  objectKey: string;
}

export interface AbstractDropzoneProps {
  meta: WrappedFieldMetaProps | FieldArrayMetaProps;
  className?: string;
}

abstract class AbstractDropzone<
  Props extends AbstractDropzoneProps
> extends React.Component<Props> {
  protected dropzoneEl;

  private static async getSignedUrl(file: File, callback) {
    const res: any = await http.get("/data/s3/sign", {
      params: { fileName: file.name },
    });

    callback({
      file,
      signedUrl: res.uri,
      bucket: res.bucket,
      objectKey: res.object_key,
    });
  }

  private static uploadOptions: UploadOptions = {
    getSignedUrl: AbstractDropzone.getSignedUrl,
    uploadRequestHeaders: {},
  };

  /**
   * Construct file url from bucket and object key, pushing new file to state
   */
  protected abstract handleFinishedUpload: (res: UploadedFileResponse) => void;
  protected abstract getDropzoneClass: () => string;
  protected abstract renderContentFiles: () =>
    | React.ReactChild
    | React.ReactChild[];

  protected assignRef = el => (this.dropzoneEl = el);

  /**
   * Trigger click action on actual file input button element
   */
  private handleUploadButton = () =>
    this.dropzoneEl._dropzone.fileInputEl.click();

  private renderError = () =>
    (this.props.meta as any).submitFailed && this.props.meta.error ? (
      <span className="form-control__error">{this.props.meta.error}</span>
    ) : (
      undefined
    );

  private getContainerClass = () => cx("dropzone", this.props.className);

  render() {
    return (
      <Layout
        dropzoneClass={this.getDropzoneClass()}
        containerClass={this.getContainerClass()}
        onFinish={this.handleFinishedUpload}
        onUploadBtnClick={this.handleUploadButton}
        assignRef={this.assignRef}
        upload={AbstractDropzone.uploadOptions}
        error={this.renderError()}
      >
        {this.renderContentFiles()}
      </Layout>
    );
  }
}

export default AbstractDropzone;



// WEBPACK FOOTER //
// ./src/components/Dropzone/AbstractDropzone.tsx